
//STYLE
import {
  ImgArrow,
  NavButton,
  SelectInput,
  SelectInputContainer,
} from "./CalendarFilterStyled";

// ASSETS
import arrowDown from "assets/svg/ArrowDownBurgundy.svg";
import yellowArrowDown from "assets/svg/ArrowDownYellow.svg";

// LIBRARIES

import { useMediaQuery } from "react-responsive";

// MISC

import { COLORS } from "constants/variables";
import { TextType } from "../CustomText/CustomTextModel";
import { CalendarType, Iprops } from "./CalendarFilterModel";

// REDUX
import { useSelector } from "react-redux";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

//COMPONENT

import CustomText from "../CustomText/CustomText";

// CONFIG
const years = Array.from({ length: 50 }, (_, i) => 2000 + i);
const CalendarFilter = (props: Iprops) => {
  // PROPS
  const { type, month, year, setMonth, setYear } = props;

  // LIBRARY CONSTANTS
  const isTablet = useMediaQuery({ maxWidth: 1400 });
  const selectedLanguage = useSelector(selectLanguage);
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS
  const getMonthNames = (locale) => {
    const date = new Date();
    return Array.from({ length: 12 }, (_, i) => {
      date.setMonth(i);
      return date.toLocaleString(locale, { month: "long" });
    });
  };
  const locale = selectedLanguage === "ro" ? "ro-RO" : "en-US";
  const months = getMonthNames(locale);

  // HANDLE EVENTS
  const handleNextMonth = () => {
    setMonth((prevIndex) =>
      prevIndex === months.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevMonth = () => {
    setMonth((prevIndex) =>
      prevIndex === 0 ? months.length - 1 : prevIndex - 1
    );
  };

  const handleNextYear = () => {
    setYear((prevIndex) =>
      prevIndex === years.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevYear = () => {
    setYear((prevIndex) =>
      prevIndex === 0 ? years.length - 1 : prevIndex - 1
    );
  };

  return (
    <SelectInputContainer type={type} biggerCursor={biggerCursor}>
      <NavButton
        biggerCursor={biggerCursor}
        onClick={
          type === CalendarType.month || type === CalendarType.girdle
            ? handlePrevMonth
            : handlePrevYear
        }
      >
        <ImgArrow
          src={
            isTablet || type === CalendarType.girdle
              ? yellowArrowDown
              : arrowDown
          }
          left={true}
        />
      </NavButton>
      <SelectInput type={type}>
        <CustomText
          type={TextType.P2}
          text={
            type === CalendarType.month || type === CalendarType.girdle
              ? months[month]
              : years[year]
          }
          color={COLORS.MetalicSilver}
        />
      </SelectInput>
      <NavButton
        biggerCursor={biggerCursor}
        onClick={
          type === CalendarType.month || type === CalendarType.girdle
            ? handleNextMonth
            : handleNextYear
        }
      >
        <ImgArrow
          src={
            isTablet || type === CalendarType.girdle
              ? yellowArrowDown
              : arrowDown
          }
          right={true}
        />
      </NavButton>
    </SelectInputContainer>
  );
};

export default CalendarFilter;
